import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for EmojiStore, for use in the registry */ export const EmojiStoreActionTypes = [
    ActionType.FetchEmojiMetadataSucceededAction,
    ActionType.FetchEmojiMetadataFailedAction
];
